"use client"

import { useState } from "react"
import { useRouter } from "next/navigation"
import { X } from "lucide-react"

/** Removes a single deadline/new-call alert from the account management list. */
export function RemoveAlertButton({ alertId }: { alertId: string }) {
  const router = useRouter()
  const [removing, setRemoving] = useState(false)

  async function remove() {
    setRemoving(true)
    const res = await fetch("/api/alerts", {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: alertId }),
    })
    if (res.ok) {
      router.refresh()
    } else {
      setRemoving(false)
    }
  }

  return (
    <button
      type="button"
      onClick={remove}
      disabled={removing}
      title="Remove alert"
      className="p-1.5 rounded-md hover:bg-red-50 transition-colors text-[var(--muted-foreground)] hover:text-red-600 disabled:opacity-50"
    >
      <X size={14} />
    </button>
  )
}
